<template>
    <section>
        <div class="row">
            <div class="col-12">
                <job-select-form></job-select-form>
            </div>
        </div>
    </section>    
</template>

<script>
import JobSelectForm from '@/components/job/SelectForm';

export default {
    components: {
        JobSelectForm
    }
}
</script>